'use client'

import Link from 'next/link'
import useLocale from '@hooks/client/useLocale'

type JobLinkProps = {
  url: string
  text: string
}

export default function JobLink({ url, text }: JobLinkProps): JSX.Element {
  const country = useLocale()

  const targetUrl = url.startsWith('/us') || url.startsWith('/uk') ? url : `/${country}${url}`

  return (
    <Link key={url} href={targetUrl} prefetch={false}>
      {text}
    </Link>
  )
}
